import styled from '@emotion/styled';
import { breakpoints, fromThemeColors, ThemeColor } from '@sharefiledev/flow-web';

export const StyledPDFViewerNavBar = styled.div`
	display: flex;
	grid-area: 3 / 1 / 4 / 2;
	justify-content: space-between;
	background-color: ${fromThemeColors(ThemeColor.secondaryContainerBackground)};
	padding: 0 40px;

	${breakpoints.onMobile} {
		padding: 0 20px;
	}
	position: sticky;
	width: 100%;
	flex-direction: column;
	z-index: 999;
`;
